var map = {
	"./ATMOS.svg": 22069,
	"./IT_Park.svg": 64801,
	"./alert-approved.svg": 52207,
	"./alert-danger.svg": 45219,
	"./alert-error.svg": 44716,
	"./alert-question.svg": 86126,
	"./alert-success.svg": 15255,
	"./arrow-left.svg": 16006,
	"./arrow-right.svg": 74213,
	"./astana-hub.svg": 83469,
	"./briefcase.svg": 75959,
	"./calendar.svg": 59671,
	"./camera.svg": 64704,
	"./certificate.svg": 48442,
	"./checked.svg": 38488,
	"./clock-regular.svg": 51586,
	"./clock.svg": 12585,
	"./content.svg": 58424,
	"./courses/course-complete.svg": 36385,
	"./diplom-error.svg": 42633,
	"./diplom.svg": 17468,
	"./doclub/attract-patients.svg": 68307,
	"./doclub/check.svg": 4759,
	"./doclub/manage-reputation.svg": 96972,
	"./doclub/registration.svg": 8194,
	"./doclub/update-personal-info.svg": 81596,
	"./doclub/update-profile.svg": 27050,
	"./doclub/upload-photo.svg": 4789,
	"./edit-alt.svg": 37347,
	"./ellipsis-vertical.svg": 64703,
	"./geo.svg": 33944,
	"./humo.svg": 66744,
	"./icon-arrow-right-base.svg": 30191,
	"./icon-bell.svg": 63380,
	"./icon-chevron-right-grey.svg": 4947,
	"./icon-chevron-right.svg": 77765,
	"./icon-chevron-up.svg": 43138,
	"./icon-close-white.svg": 60617,
	"./icon-close.svg": 3413,
	"./icon-crown.svg": 24564,
	"./icon-download.svg": 76527,
	"./icon-exit.svg": 76995,
	"./icon-external-link.svg": 95807,
	"./icon-file-grey.svg": 65115,
	"./icon-file.svg": 66685,
	"./icon-filter.svg": 74201,
	"./icon-heart-blue-filled.svg": 53391,
	"./icon-heart-blue.svg": 48938,
	"./icon-heart.svg": 53965,
	"./icon-mark.svg": 7068,
	"./icon-people.svg": 3102,
	"./icon-person.svg": 48700,
	"./icon-plane.svg": 81347,
	"./icon-plus.svg": 76739,
	"./icon-search.svg": 32335,
	"./icon-share.svg": 71500,
	"./icon-star.svg": 34999,
	"./icon-tick.svg": 14656,
	"./icon-transaction.svg": 72645,
	"./icon-white-plus.svg": 59327,
	"./icon-yandex.svg": 96020,
	"./it-park.svg": 459,
	"./landing/doctors-community.svg": 48771,
	"./landing/document.svg": 17906,
	"./landing/education-course.svg": 53365,
	"./landing/education.svg": 30033,
	"./landing/increase-schedule.svg": 32133,
	"./landing/online-conferences.svg": 86910,
	"./like-regular.svg": 15743,
	"./like-solid.svg": 68330,
	"./live.svg": 29711,
	"./logo-copy.svg": 3538,
	"./logo.svg": 90160,
	"./mail-2.svg": 19349,
	"./mail.svg": 51192,
	"./materials/icon-chat.svg": 8238,
	"./materials/icon-education.svg": 35822,
	"./materials/icon-events.svg": 65799,
	"./materials/icon-materials.svg": 10310,
	"./materials/icon-media.svg": 85144,
	"./materials/icon-presentation.svg": 16540,
	"./mdi-account-circle.svg": 20810,
	"./mdi-check-circle-outline.svg": 35792,
	"./mdi-check.svg": 31112,
	"./mdi-chevron-down.svg": 63390,
	"./mdi-chevron-left.svg": 68309,
	"./mdi-chevron-right.svg": 66520,
	"./mdi-clock.svg": 37282,
	"./mdi-close-circle.svg": 13281,
	"./mdi-close.svg": 83124,
	"./mdi-information-outline.svg": 1763,
	"./mdi-refresh.svg": 26073,
	"./megafon--large.svg": 79155,
	"./module/checked.svg": 3039,
	"./module/presentation-done.svg": 67845,
	"./module/presentation.svg": 68484,
	"./module/tests-done.svg": 41524,
	"./module/tests.svg": 32971,
	"./module/video-done.svg": 34626,
	"./module/video.svg": 43605,
	"./no-image copy.svg": 53783,
	"./no-image.svg": 2432,
	"./not-verified.svg": 7001,
	"./official-certificate.svg": 14832,
	"./pass-error.svg": 19923,
	"./pass.svg": 12366,
	"./pdf-com.svg": 35629,
	"./period.svg": 66490,
	"./person.svg": 61358,
	"./personal-page.svg": 39767,
	"./plus.svg": 62833,
	"./premium.svg": 38648,
	"./shield.svg": 86986,
	"./sparkling.svg": 78232,
	"./star.svg": 30289,
	"./success.svg": 69102,
	"./teacher.svg": 19273,
	"./telegram.svg": 1296,
	"./tg.svg": 49838,
	"./upload.svg": 45294,
	"./uzcard.svg": 75086,
	"./video-square.svg": 85610,
	"./warn.svg": 94973,
	"./webinar.svg": 97909
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52329;